// extracted by mini-css-extract-plugin
export default {"container":"VideoPlayer_container__aN7Eu","video":"VideoPlayer_video__3ZwHP","overlay":"VideoPlayer_overlay__UdvZi"};